import React from "react";

const CautionIcon = ({ width, height, fill, stroke }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.9856 3.3983C41.8627 1.06385 33.4441 -0.0794081 24.9928 0.00428289C16.5415 -0.0794081 8.12287 1.06385 0 3.3983L0 46.6017C8.12287 48.9362 16.5415 50.0794 24.9928 49.9957C33.4441 50.0794 41.8627 48.9362 49.9856 46.6017V3.3983Z"
        fill={fill}
      />
      <path
        d="M24.3236 29.817C23.3899 29.817 22.6472 30.4748 22.6472 31.3873C22.6472 32.2997 23.3899 33 24.3236 33C25.2785 33 26 32.2997 26 31.3873C26 30.4748 25.2785 29.817 24.3236 29.817ZM25.6817 18.1034L22.9443 18.1034L22.9443 28.565L25.6817 27.992L25.6817 18.1034Z"
        fill={stroke}
      />
      <circle
        cx="25"
        cy="25"
        r="14.0441"
        stroke={stroke}
        strokeWidth="3.91176"
      />
    </svg>
  );
};

CautionIcon.defaultProps = {
  width: 50,
  height: 50,
  fill: "#333",
  stroke: "white",
};

export default CautionIcon;
